import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const placeEventRoute: RouteConfig<'with-page'> = {
    name: 'Place an Event',
    path: '/work-opps/place-event',
    page: lazy(() => import('.')),
    context: 'member',
    flags: ['member-route'],
    permissions: ['workOps'],
}
